import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';

export default {
  name: 'TRUE',
  category: FunctionCategory.LOGIC,
  shortDescription: 'Returns the value TRUE.',
  description:
    'Returns the value TRUE. This is equivalent to the TRUE literal and is included only to provide compatibility with other spreadsheet programs.',
  params: [],
  eval: (): true => true,
} satisfies EvaluablePrimitiveSpreadsheetFunction;
